// extracted by mini-css-extract-plugin
export default {"ModalOverlay":"bomModal-module_ModalOverlay_yamqR","Modal":"bomModal-module_Modal__aQ2m","Iframe":"bomModal-module_Iframe_VvLxt"};